/* eslint-disable react/forbid-component-props */
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { SITE_LIVINGSOCIAL_IE } from '../../config/setup/setup';
import ThemeContext from '../../providers/ThemeProvider';
import WowModal from '../WowModal';

const ClearpayModal = ({
  currentRef,
  price,
  setShowClearpayModal,
  showClearpayModal,
}) => {
  /*   const theme = useContext(ThemeContext);
  const closeModal = () => {
    setShowClearpayModal(false);
  };
  const livingsocialie = process.env.NEXT_PUBLIC_SITE === SITE_LIVINGSOCIAL_IE;
  const overThirtyFive = price > 35;
 */
  return (
    <>
      <WowModal
        ariaLabelledBy=""
        centered
        container={currentRef}
        extraClasses="range-modal"
        setShowModal={setShowClearpayModal}
        showHeader={false}
        showModal={showClearpayModal}
        size="lg"
      >
        <div className="modal-container" data-testid="clearpay-modal-container">
          <div className="afterpay-modal-wrapper" id="afterpay-modal-container">
            <div className="grid-container">
              <div className="row-0">
                <div className="afterpay-modal-logo">
                  <svg
                    aria-label="Clearpay logo"
                    className="afterpay-logo-black"
                    role="img"
                    viewBox="0 0 1150 225"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M912.9 55.2l-78.6 162h-32.5l29.3-60.5-46-101.5h33.4l29.6 68 32.3-68H913zM614 112.7c0-18.5-14-32.9-31.2-32.9s-31.3 13.9-31.3 33c0 18.8 14 32.9 31.3 32.9a31.9 31.9 0 0031.3-33M523 217.2v-162h28.2v15A45.7 45.7 0 01587.6 53c31 0 55.4 25.6 55.4 59.4S618.1 172 587 172a44.5 44.5 0 01-34.8-15.4v60.5H523v.1zM745 112.7c0-19.3-14-32.9-31.2-32.9s-31.3 13.9-31.3 33c0 18.8 14 32.9 31.3 32.9 17.2 0 31.3-13.7 31.3-33m.2 57.6v-15a46 46 0 01-36.3 16.8c-31.6 0-55.5-25.3-55.5-59.4 0-33.7 24.9-59.5 56.1-59.5a46 46 0 0135.7 16.6V55.2h28.2v115h-28.2zM472 66.5S479 53 496.7 53c7.6 0 12.4 2.6 12.4 2.6v29.4s-10.6-6.6-20.4-5.3c-9.8 1.4-16 10.3-16 22.3v68.2h-29.2v-115h28.3v11.2zM1132.4 48.7L1099 29.6 1065 10a33.7 33.7 0 00-50.5 29.3v4.3c0 2.4 1.3 4.7 3.4 5.8l15.8 9a6.5 6.5 0 009.8-5.7V42.5c0-5.2 5.5-8.4 10-5.9l31 17.9 30.8 17.7c4.5 2.5 4.5 9 0 11.5l-30.9 17.7-31 17.8a6.7 6.7 0 01-10-5.8v-5.1c0-26-28-42.2-50.5-29.3l-34 19.5-33.4 19.2a33.8 33.8 0 000 58.6l33.5 19.1 34 19.5a33.7 33.7 0 0050.5-29.3v-4.3c0-2.4-1.3-4.7-3.4-5.8l-15.8-9a6.5 6.5 0 00-9.8 5.7v10.3c0 5.2-5.5 8.4-10 5.9l-31-17.9-30.8-17.7a6.6 6.6 0 010-11.5l30.9-17.7 31-17.8c4.4-2.5 10 .6 10 5.8v5.1c0 26 28 42.2 50.5 29.3l34-19.5 33.4-19.2a33.8 33.8 0 000-58.6zM118.6 127.4A57.8 57.8 0 0160.2 172c-34 0-59.6-25.6-59.6-59.4s26-59.5 60-59.5a58 58 0 0157.8 44.2h-30A31.3 31.3 0 0061 80c-17 0-31.3 14-31.3 32.6s14.2 32.7 31.3 32.7c12.2 0 22.7-6.9 27.7-18h30zM132 170.2V7.9h29v162.3h-29zM204.5 120.3c2 17 14.3 26.6 29.7 26.6 12.2 0 21.6-5.7 27-14.9H291c-6.9 24.4-28.8 40-57.5 40-34.8 0-59-24.4-59-59S200 53.1 234 53.1a57.5 57.5 0 0158.3 67h-87.9zm57.7-18c-2-15-14.2-24-28.4-24-14.3 0-26 8.8-29 24h57.4zM396.5 170.2v-15a46 46 0 01-36.3 16.8c-31.4 0-55.4-25.3-55.4-59.4 0-33.7 24.8-59.5 56.1-59.5 14.7 0 27.1 6.4 35.6 16.6V55h28.3v115h-28.3zm-.3-57.6c0-19.2-14-32.9-31.2-32.9-17.3 0-31.3 13.8-31.3 33 0 18.8 14 32.9 31.3 32.9 17.2 0 31.2-13.6 31.2-33z" />
                  </svg>
                </div>
              </div>
              <div className="row-1">
                <h3 className="afterpay-modal-headline">
                  Shop now. <span>Pay later.</span>
                  <div>Always interest-free.</div>
                </h3>
              </div>
              <div className="process-step-1 process-icon-container">
                <svg
                  aria-label="Step 1"
                  className="process-icon shopping-cart"
                  role="img"
                  viewBox="0 0 52 72"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="c1"
                    d="M26 55.47a27.28 27.28 0 01-4-3c-2.13-1.87-4.52-4.49-4.44-7.36a5 5 0 01.37-1.75 4.27 4.27 0 018.13.25 4.27 4.27 0 018.13-.25 5 5 0 01.37 1.75c.08 2.87-2.31 5.49-4.44 7.36a27.28 27.28 0 01-4 3"
                  />
                  <path
                    className="c1"
                    d="M10.5 35V17a15.5 15.5 0 0131 0v18"
                    fill="#000"
                  />
                  <path
                    className="c1"
                    d="M110.5 30.5h45.79a4.21 4.21 0 014.21 4.21v40.58a4.21 4.21 0 01-4.21 4.21H110.5v-49z"
                    transform="rotate(90 85.5 -4.5)"
                  />
                </svg>
              </div>
              <div className="process-step-1 process-subheading">
                Add your favourites to cart
              </div>
              <div className="process-step-2 process-icon-container">
                <svg
                  aria-label="Step 2"
                  className="process-icon afterpay-desktop"
                  role="img"
                  viewBox="0 0 82 56"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path className="c1" d="M36.5 52.49h9" />
                  <path
                    className="c1"
                    d="M10.43 1.5h61.14a3.93 3.93 0 013.93 3.93V50.5h-69V5.43a3.93 3.93 0 013.93-3.93z"
                  />
                  <path d="M54.75 17.52L50.3 15l-4.51-2.59a4.48 4.48 0 00-6.71 3.89v.58a.89.89 0 00.44.77l2.1 1.2a.86.86 0 001.3-.75v-1.41a.89.89 0 011.33-.77l4.12 2.37 4.11 2.36a.88.88 0 010 1.53l-4.11 2.36-4.12 2.36a.88.88 0 01-1.33-.76v-.69a4.48 4.48 0 00-6.71-3.89l-4.51 2.59-4.45 2.55a4.49 4.49 0 000 7.78L31.7 37l4.51 2.59a4.48 4.48 0 006.71-3.89v-.58a.88.88 0 00-.44-.77l-2.1-1.2a.86.86 0 00-1.3.75v1.38a.89.89 0 01-1.33.77l-4.12-2.37-4.11-2.36a.88.88 0 010-1.53l4.11-2.36 4.12-2.36a.88.88 0 011.33.76v.69a4.48 4.48 0 006.71 3.89l4.51-2.59 4.45-2.55a4.49 4.49 0 000-7.75z" />
                  <rect
                    className="c1"
                    height="4"
                    rx="2"
                    width="79"
                    x="1.5"
                    y="50.49"
                  />
                </svg>
                <svg
                  aria-label="Step 2"
                  className="process-icon afterpay-mobile"
                  role="img"
                  viewBox="0 0 52 82"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    className="c1"
                    height="49"
                    rx="4.21"
                    transform="rotate(90 76 -9)"
                    width="79"
                    x="86.5"
                    y="16.5"
                  />
                  <path className="c1" d="M1.49 10.5h49" />
                  <path className="c1" d="M1.49 75.5h49" />
                  <path className="c1" d="M21.49 6.5h9" />
                  <path d="M39.75 32.52L35.3 30l-4.51-2.59a4.48 4.48 0 00-6.71 3.89v.58a.89.89 0 00.44.77l2.1 1.2a.86.86 0 001.3-.75v-1.41a.89.89 0 011.33-.77l4.12 2.37 4.11 2.36a.88.88 0 010 1.53l-4.11 2.36-4.12 2.36a.88.88 0 01-1.33-.76v-.69a4.48 4.48 0 00-6.71-3.89l-4.51 2.59-4.45 2.55a4.49 4.49 0 000 7.78L16.7 52l4.51 2.59a4.48 4.48 0 006.71-3.89v-.58a.88.88 0 00-.44-.77l-2.1-1.2a.86.86 0 00-1.3.75v1.38a.89.89 0 01-1.33.77l-4.12-2.37-4.11-2.36a.88.88 0 010-1.53l4.11-2.36 4.12-2.36a.88.88 0 011.33.76v.69a4.48 4.48 0 006.71 3.89l4.51-2.59 4.45-2.55a4.49 4.49 0 000-7.75z" />
                </svg>
              </div>
              <div className="process-step-2 process-subheading">
                Select Clearpay at checkout
              </div>
              <div className="process-step-3 process-icon-container">
                <svg
                  aria-label="Step 3"
                  className="process-icon sign-up-desktop"
                  role="img"
                  viewBox="0 0 82 56"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path className="c1" d="M52.51 28.12l4.43 4.45L65.5 24" />
                  <circle className="c1" cx="31" cy="26" r="14.5" />
                  <circle className="c1" cx="31" cy="21.8" r="6.09" />
                  <path
                    className="c1"
                    d="M20.92 36.42a8.43 8.43 0 018-5.8h4.2a8.45 8.45 0 018 5.8M36.5 52.49h9"
                  />
                  <path
                    className="c1"
                    d="M10.43 1.5h61.14a3.93 3.93 0 013.93 3.94V50.5h-69V5.45a3.93 3.93 0 013.93-3.93z"
                  />
                  <rect
                    className="c1"
                    height="4"
                    rx="2"
                    width="79"
                    x="1.5"
                    y="50.49"
                  />
                </svg>
                <svg
                  aria-label="Step 3"
                  className="process-icon sign-up-mobile"
                  role="img"
                  viewBox="0 0 52 82"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    className="c1"
                    height="49"
                    rx="4.21"
                    transform="rotate(90 76 -9)"
                    width="79"
                    x="86.5"
                    y="16.5"
                  />
                  <path
                    className="c1"
                    d="M21.46 58.06l4.43 4.45 8.55-8.58M1.5 10.5h48.99M1.5 75.5h48.99M21.5 6.5h9"
                  />
                  <circle className="c1" cx="26" cy="34" r="14.5" />
                  <circle className="c1" cx="26" cy="29.8" r="6.09" />
                  <path
                    className="c1"
                    d="M15.93 44.42a8.43 8.43 0 018-5.8h4.2a8.45 8.45 0 018 5.79"
                  />
                </svg>
              </div>
              <div className="process-step-3 process-subheading">
                Log into or create your Clearpay account, instant approval
                decision
              </div>
              <div className="process-step-4 process-icon-container">
                <svg
                  aria-label="Step 4"
                  className="process-icon four-payments"
                  role="img"
                  viewBox="14 7 79 79"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="c1"
                    d="M50,15.5A34.5,34.5,0,0,0,15.5,50H50Z"
                  />
                  <path
                    className="c1"
                    d="M15.5,50A34.5,34.5,0,0,0,50,84.5V50Z"
                  />
                  <path
                    className="c1"
                    d="M50,84.5h0A34.5,34.5,0,0,0,84.5,50H50Z"
                  />
                  <path
                    className="c1"
                    d="M57,8.5h0V43h34.5A34.5,34.5,0,0,0,57,8.5Z"
                  />
                </svg>
              </div>
              <div className="process-step-4 process-subheading">
                Your purchase will be split into 4 payments, payable every 2
                weeks
              </div>
              <div className="row-3">
                <div className="disclaimer">
                  Clearpay lends you a fixed amount of credit so you can pay for
                  your purchase over 4 instalments, due every 2 weeks.
                  <br />
                  Ensure you can make repayments on time. You must be 18+ and a
                  permanent UK resident (excl Channel Islands).
                  <br />
                  Clearpay charges a £6 late fee for each late instalment and a
                  further £6 if it’s still unpaid 7 days later.
                  <br />
                  Late fees are capped at £6 for orders under £24 and the lower
                  of £24 or 25% of the order value for orders over £24.
                  <br />
                  Missed payments may affect your ability to use Clearpay in the
                  future and your details may be passed onto a debt collection
                  agency working on Clearpay’s behalf.
                  <br />
                  Clearpay is credit that is not regulated by the Financial
                  Conduct Authority.
                  <br />
                  T&Cs and other eligibility criteria apply at{' '}
                  <a
                    aria-label="Clearpay Terms (New Window)"
                    className="disclaimer-link"
                    href="https://www.clearpay.co.uk/en-GB/terms-of-service"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    clearpay.co.uk/terms
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </WowModal>
      <style jsx>{`
        body.afterpay-modal-body,
        html.afterpay-modal-html {
          height: 100%;
        }
        body.afterpay-modal-body {
          margin: 0;
          background-color: #b2fce4;
        }
        body.afterpay-modal-body.theme-white {
          background: #fff;
        }
        .afterpay-modal-wrapper {
          min-height: 100%;
          padding: 0 24px;
          background: #b2fce4;
        }
        .afterpay-modal-wrapper.theme-white {
          background: #fff;
        }
        .afterpay-modal-wrapper * {
          box-sizing: border-box;

          font-family: 'Italian Plate No2 Expanded', sans-serif;
          color: #000;
        }
        .grid-container {
          display: grid;
          margin: 0 auto;
          max-width: 800px;
          text-align: center;
          font-size: 16px;
          grid-template-rows: auto;
          grid-template-columns: repeat(4, 25%);
          grid-template-areas: 'logo logo logo logo' 'headline headline headline headline' 'body-a body-b body-c body-d' 'body-e body-f body-g body-h' 'cbt-block cbt-block cbt-block cbt-block' 'footer footer footer footer';
        }
        .row-0 {
          grid-area: logo;
          padding-top: 45px;
        }
        .row-1 {
          grid-area: headline;
          padding: 3% 0 8% 0;
        }
        .process-step-1.process-icon-container {
          grid-area: body-a;
        }
        .process-step-2.process-icon-container {
          grid-area: body-b;
        }
        .process-step-3.process-icon-container {
          grid-area: body-c;
        }
        .process-step-4.process-icon-container {
          grid-area: body-d;
        }
        .process-step-1.process-subheading {
          grid-area: body-e;
        }
        .process-step-2.process-subheading {
          grid-area: body-f;
        }
        .process-step-3.process-subheading {
          grid-area: body-g;
        }
        .process-step-4.process-subheading {
          grid-area: body-h;
        }
        .row-3 {
          grid-area: footer;
        }
        .grid-container > div {
          align-content: stretch;
        }
        .afterpay-modal-logo svg {
          width: 100%;
          max-width: 275px;
          height: auto;
        }
        h3.afterpay-modal-headline {
          margin: 0;
          font-size: 44px;
          font-weight: 600;
          line-height: 1.1;
        }
        .process-icon-container {
          align-self: end;
        }
        .process-icon-container svg {
          width: auto;
          height: auto;
          max-width: 110px;
          max-height: 95px;
        }
        .process-icon-container svg .c1 {
          fill: none;
          stroke: #000;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-width: 2px;
        }
        .process-subheading {
          padding: 10% 3% 0 3%;
          font-weight: 600;
          line-height: 1.25;
        }
        svg.afterpay-mobile,
        svg.sign-up-mobile {
          display: none;
        }
        .row-3 {
          padding: 8% 0 40px 0;
        }
        .disclaimer {
          font-size: 12px;
        }
        .disclaimer-link {
          color: #000;
          text-decoration: underline;
        }
        .disclaimer-link:active {
          color: #000;
        }
        .afterpay-footer-example {
          margin-top: 1.875em;
          font-size: x-small;
          font-weight: 600;
        }
        .afterpay-underline {
          text-decoration: underline;
        }
        .afterpay-bold {
          font-weight: 700;
        }
        .afterpay-euro-symbol:after {
          font-weight: 400;
        }
        .afterpay-reference-symbol {
          font-weight: 400;
          font-size: 0.5em;
          vertical-align: text-top;
        }
        @media (max-width: 768px) {
          .grid-container {
            max-width: 500px;
            grid-template-columns: auto;
            grid-template-areas: 'logo logo' 'headline headline' 'body-a body-b' 'body-e body-f' 'body-c body-d' 'body-g body-h' 'cbt-block cbt-block' 'footer footer';
          }
          .row-1 {
            padding: 3% 0 20px 0;
          }
          .process-icon-container {
            padding: 24px 0 0 0;
          }
        }
        @media (max-width: 600px) {
          .afterpay-modal-wrapper {
            padding: 0;
          }
          .grid-container {
            padding: 30px;
            text-align: left;
            grid-template-columns: auto;
            grid-template-areas: 'logo logo' 'headline headline' 'body-a body-e' 'body-b body-f' 'body-c body-g' 'body-d body-h' 'cbt-block cbt-block' 'footer footer';
          }
          .row-0 {
            padding-top: 0;
          }
          .row-1 {
            padding: 20px 0 8% 0;
          }
          h3.afterpay-modal-headline {
            font-size: 40px;
          }
          svg.afterpay-desktop,
          svg.sign-up-desktop {
            display: none;
          }
          svg.afterpay-mobile,
          svg.sign-up-mobile {
            display: block;
          }
          .process-icon-container {
            align-self: start;
            padding: 12px 0;
          }
          .process-icon-container svg {
            min-width: 30px;
            max-height: 65px;
          }
          .process-subheading {
            padding: 6px 0 6px 12px;
            align-self: center;
          }
          .row-3 {
            padding: 8% 0 20px 0;
          }
        }
        @media (max-width: 420px) {
          .afterpay-modal-logo svg {
            max-width: 200px;
          }
          h3.afterpay-modal-headline {
            font-size: 36px;
          }
        }
        @media (max-width: 335px) {
          h3.afterpay-modal-headline {
            font-size: 32px;
          }
        }
        @media (max-width: 260px) {
          .grid-container {
            font-size: 14px;
          }
          h3.afterpay-modal-headline {
            font-size: 28px;
          }
        }
        @media (-ms-high-contrast: none), (-ms-high-contrast: active) {
          .afterpay-modal-wrapper .grid-container {
            display: -ms-grid;
            -ms-grid-rows: auto;
            -ms-grid-columns: (25%) [4];
            font-size: 14px;
          }
          .afterpay-modal-wrapper .grid-container .row-0 {
            -ms-grid-row: 1;
            -ms-grid-column: 1;
            -ms-grid-column-span: 4;
            padding-top: 0;
          }
          .afterpay-modal-wrapper
            .grid-container
            .row-0
            .afterpay-modal-logo
            svg {
            height: 15vh;
          }
          .afterpay-modal-wrapper .grid-container .row-1 {
            -ms-grid-row: 2;
            -ms-grid-column: 1;
            -ms-grid-column-span: 4;
            padding: 20px 0 45px 0;
          }
          .afterpay-modal-wrapper
            .grid-container
            .process-step-1.process-icon-container {
            -ms-grid-row: 3;
            -ms-grid-column: 1;
          }
          .afterpay-modal-wrapper
            .grid-container
            .process-step-2.process-icon-container {
            -ms-grid-row: 3;
            -ms-grid-column: 2;
          }
          .afterpay-modal-wrapper
            .grid-container
            .process-step-3.process-icon-container {
            -ms-grid-row: 3;
            -ms-grid-column: 3;
          }
          .afterpay-modal-wrapper
            .grid-container
            .process-step-4.process-icon-container {
            -ms-grid-row: 3;
            -ms-grid-column: 4;
            grid-area: body-d;
          }
          .afterpay-modal-wrapper
            .grid-container
            .process-step-1.process-subheading {
            -ms-grid-row: 4;
            -ms-grid-column: 1;
            grid-area: body-e;
          }
          .afterpay-modal-wrapper
            .grid-container
            .process-step-2.process-subheading {
            -ms-grid-row: 4;
            -ms-grid-column: 2;
            grid-area: body-f;
          }
          .afterpay-modal-wrapper
            .grid-container
            .process-step-3.process-subheading {
            -ms-grid-row: 4;
            -ms-grid-column: 3;
          }
          .afterpay-modal-wrapper
            .grid-container
            .process-step-4.process-subheading {
            -ms-grid-row: 4;
            -ms-grid-column: 4;
          }
          .afterpay-modal-wrapper .grid-container .row-3 {
            -ms-grid-row: 5;
            -ms-grid-column: 1;
            -ms-grid-column-span: 4;
            padding: 80px 0 40px 0;
          }
        }
      `}</style>
    </>
  );
};

ClearpayModal.propTypes = {
  currentRef: PropTypes.object,
  price: PropTypes.number,
  setShowClearpayModal: PropTypes.func,
  showClearpayModal: PropTypes.bool,
};

export default ClearpayModal;
